/**
 * D-263 - pure rules of the status pill of a task row / the task page (unit-tested in
 * `src/utils/__tests__/d263TaskStatusPill.test.ts`).
 */

/**
 * D-263 round 2 - who the SERVER lets change a status (`requireOteStaff('agent')`): any OTE employee, also one whose
 * login role is customer_manager. `isOteEmployee` (GET /permissions/me) wins once it answered; before that the claim.
 * A portal customer is never staff.
 */
export function canUseTaskStatusPill(role: string | null | undefined, isOteEmployee: boolean | undefined): boolean {
  return isOteEmployee ?? (role === 'admin' || role === 'agent');
}

/** Who gets the list: staff, on a task that is neither completed nor cancelled (same as the task page). Others see the plain badge. */
export function canChangeTaskStatus(o: { isStaff: boolean; status: string; cancelled_at?: string | null }): boolean {
  return o.isStaff && !o.cancelled_at && o.status !== 'completed';
}

/** "הושלם" on a task with MY running timer: the finish window (it stops the timer) opens before the status is saved. */
export function needsFinishWindow(next: string, timers: { ticket_id?: string | null }[] | null | undefined, taskId: string): boolean {
  return next === 'completed' && (timers ?? []).some((tm) => tm.ticket_id === taskId);
}
